import { memo, useCallback, useState } from "react";

import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";
import { ContactEmailSearchFilterProps } from "./types";
import { ContactEmailSearchFormValues } from "services/api/contacts/types";
import { initialContactEmailSearchForm } from "services/api/contacts/consts";

const ContactEmailSearchFilters: React.FC<ContactEmailSearchFilterProps> = (
  props
) => {
  const { onAddNew, onSearchChange } = props;

  const [formValues, setFormValues] = useState<ContactEmailSearchFormValues>(
    initialContactEmailSearchForm
  );

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const updatedFormValues = { ...formValues, search: e.target.value };
    setFormValues(updatedFormValues);
    onSearchChange(updatedFormValues);
  };


  const handleResetFormClick = useCallback(() => {
    const updatedFormValues = { ...formValues, search: "" };
    setFormValues(initialContactEmailSearchForm);
    onSearchChange(updatedFormValues);
  }, []);

  return (
    <>
      <div className=" ">
        <div className="flex justify-between items-center gap-3">
          <div className="flex">
            <div className="mr-3">
              <TextField
                type="text"
                name="search"
                value={formValues.search}
                onChange={handleSearchChange}
                placeholder="Pretraži"
                startIcon="../media/icons/search.svg"
                cssClassName="bg-white"
              />
            </div>

            <div className="mr-3 flex items-center">
              <span
                onClick={handleResetFormClick}
                className="text-xs font-bold cursor-pointer text-gray-700"
              >
                RESET
              </span>
            </div>
          </div>
          <div className=" py-3 flex justify-end ">
            <Button
              variant="primary"
              children="Dodaj email adresu"
              startIcon="/media/icons/plus.svg"
              onClick={onAddNew}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(ContactEmailSearchFilters);
